import { io } from "socket.io-client";
import { env } from "../datas.config";

const URL = env.domain;

export let socket = null;

let _currentWorkspaceId = null;
let _currentWorkspaceRole = null;
let _currentPermissions = [];
let _userId = null;

export function getCurrentSocketRole() {
  return _currentWorkspaceRole;
}

export function getCurrentSocketPermissions() {
  return _currentPermissions;
}

export function setSocketPermissions(role, permissions) {
  _currentWorkspaceRole = role;
  _currentPermissions = permissions || [];
}

export function setSocketUserId(userId) {
  _userId = userId;
}

export function updateSocketWorkspace(workspaceId) {
  if (workspaceId === _currentWorkspaceId) return;

  if (workspaceId) {
    _currentWorkspaceId = workspaceId;
  }

  if (!socket || !socket.connected) return;

  socket.emit("select_workspace", workspaceId, (res) => {
    if (res && res.success) {
      _currentWorkspaceRole = res.role || null;
      _currentPermissions = res.permissions || [];
      if (_userId) {
        socket.emit("client_joint_toutes_ses_rooms", _userId);
      }
    }
  });
}

export function initSocket() {
  if (socket && socket.connected) return socket;
  if (socket) {
    socket.removeAllListeners();
    socket = null;
  }

  socket = io(URL, {
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 30000,
    withCredentials: true,
    timeout: 20000,
    forceNew: false,
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    startInactivityTimer();
    if (_currentWorkspaceId) {
      socket.emit("select_workspace", _currentWorkspaceId, (res) => {
        if (res && res.success && _userId) {
          socket.emit("client_joint_toutes_ses_rooms", _userId);
        }
      });
    }
  });

  socket.on("disconnect", (reason) => {
    console.log("Deconnecte du serveur Socket.IO. Raison:", reason);
    stopInactivityTimer();
    if (reason === "io server disconnect") {
      socket.connect();
    }
  });

  socket.on("reconnect_attempt", (attemptNumber) => {
    console.log(`Tentative de reconnexion #${attemptNumber}`);
  });

  socket.onAny(() => {
    stopInactivityTimer();
    startInactivityTimer();
  });

  const originalEmit = socket.emit;
  socket.emit = function (event, ...args) {
    stopInactivityTimer();
    startInactivityTimer();
    originalEmit.apply(socket, [event, ...args]);
  };

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    _currentWorkspaceId = null;
    _currentWorkspaceRole = null;
    _currentPermissions = [];
    _userId = null;
    socket.disconnect();
  }
}

let inactivityTimer;

const startInactivityTimer = () => {
  inactivityTimer = setTimeout(
    () => {
      console.log("Deconnexion automatique due a l'inactivite");
      if (socket) socket.disconnect();
    },
    1000 * 3600 * 12
  );
};

const stopInactivityTimer = () => {
  clearTimeout(inactivityTimer);
};
